<!-- Holiday hours notice -->
<div class="holiday-notice" [innerHtml]="html" *ngIf="html"></div>
